import React, { useEffect, useState } from "react";
import hero_1 from "../../assets/hero-4.png";
import hero_2 from "../../assets/hero-5.png";
import hero_3 from "../../assets/hero-6.jpg";
import icon from "../../assets/icon.png";
import circle from '../../assets/circle.png';

const heroImages =[hero_1,hero_2,hero_3]

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 4000); // change every 4 seconds
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="relative flex min-h-[680px] w-full flex-col lg:h-[80vh] lg:min-h-[620px] lg:flex-row">
      {/* Left Text */}
      <div className="flex w-full flex-1 flex-col items-start justify-center gap-6 bg-black px-5 py-14 sm:px-8 lg:w-1/2 lg:px-16 lg:py-0">
        <div className="flex gap-[5px] ">
          <img
            src={icon}
            alt=""
            className="w-[24px]  h-[24px] object-contain"
          />
          <p className="text-sm font-Quicksand text-white sm:text-lg">
            Full-Service Real Estate & Property Management
          </p>
        </div>
        <h1 className="text-4xl leading-tight font-bold text-gradient sm:text-5xl lg:text-[55px]">
          Trusted Property Experts In the Bay Area
        </h1>
        <p className="text-base leading-relaxed text-white font-light sm:text-lg">
          With over 20 years of industry experience, we provide professional
          real estate and property management solutions across the San Francisco
          and Bay Area. From residential homes to commercial properties and
          shopping centers, our licensed team is dedicated to protecting your
          investment and maximizing your returns.
        </p>
        <div className="w-full">
          <div className="flex w-full flex-wrap gap-3">
            <a href="https://resanfrancisco.rapmls.com/scripts/mgrqispi.dll?APPNAME=REsanfrancisco&PRGNAME=MLSLogin&ARGUMENT=xBI9EtEjQhchnRw3UM3ur1Fv2bvgEOWqz%2BBWAP7ut5s%3D&KeyRid=1&MLS_Origin=SFAR&HM=Y&pg=criteria" className="buttons inline-flex min-h-11 items-center justify-center rounded-lg px-5 py-2 font-Outfit text-base text-black sm:text-lg">
              Find My Properties
            </a>
            {/* <button
              onClick={() => setSearch("rent")}
              className={`py-[0.4rem] px-[1.5rem] rounded-tl-lg rounded-tr-lg font-Outfit text-[18px] ${search === "rent" ? "bg-white" : "bg-[#b1b1b1]"}`}
            >
              Rent
            </button> */}
          </div>
          {/* <div className="py-[0.3rem] flex justify-between items-center pl-[1.5rem] pr-[0.3rem] gap-[10px] w-[80%] bg-white rounded-tr-lg rounded-bl-lg rounded-br-lg">
            <div className="flex items-center text-gray-500 gap-[0.5rem] h-[35px] flex-1">
              <FaSearch size={"18px"} />
              <input
                type="text"
                placeholder="Search by City, Neighborhood, Address, School, Zip Code..."
                className="outline-none w-full text-[18px]"
              />
            </div>

            <Buttons title="Search" width="120px" />
          </div> */}
        </div>
      </div>

      {/* Right Image with Gradient */}
      <div className="relative min-h-[260px] w-full flex-1 lg:h-full lg:w-1/2">
       {heroImages.map((img, index) => (
        <img
          key={index}
          src={img}
          alt="Hero"
          className={`
            absolute top-0 left-0 w-full h-full object-cover
            transition-opacity duration-1000
            ${index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"}
          `}
        />
      ))}

        {/* Gradient Overlay */}
        <div
          className="z-50 absolute top-0 right-0 h-full w-full pointer-events-none"
          style={{
            background:
              "linear-gradient(238.21deg, #EEC24B 8.76%, rgba(238, 194, 75, 0) 50.09%)",
          }}
        ></div>
      </div>

       <div className="spinner absolute left-1/2 top-1/2 z-50 flex h-24 w-24 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full animate-spin-slow sm:h-36 sm:w-36 lg:left-[45%] lg:top-[25%] lg:h-[180px] lg:w-[180px] lg:translate-x-0 lg:translate-y-0">
             <img src={circle} alt="" />
</div>
    </div>
  );
};

export default Hero;
